<template>

  <div class="product">
     <ul>
          <li v-for="(url,index) in urls" :key="index" >
            <router-link  v-bind:to="'/news/'+url.id"><img v-bind:src="url.thumb"/></router-link>
          </li>
        </ul>
    </div>
</template>

<script>

export default {
  name: 'product',
  data () {
    return {
      urls: []
    }
  },
  created () {
    const self = this
    this.$axios.get('/cms/getcolumn/2')
      .then(function (res) {
        self.urls = res.data.data
      })
  }
}
</script>

<style scoped>
  .product {
    width: 100%;
    margin: 0 auto;
  }
  li{
    float: left;
    list-style:none;
  }

  .product img{
    height: 400px;
    border-radius: 10px;
    width: 235px;
    margin: 20px;
  }
</style>
